import { useEffect, useState } from 'react';

/**
 * Subscribe to a CSS media query and re-render on changes. Used to drive
 * JS-side responsive decisions (e.g. the sidebar collapse rail is a
 * desktop-only affordance) that can't be expressed with Tailwind classes alone.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState<boolean>(() =>
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false,
  );

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const mql = window.matchMedia(query);
    const onChange = (event: MediaQueryListEvent): void => setMatches(event.matches);
    setMatches(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}
